import React from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import EyeImg from "../Assest/images/eyeglass.png";
import EyeImg1 from "../Assest/images/cute-gile-sunglasses.png";
import EyeImg2 from "../Assest/images/left-side-girl.png";
import EyeImg3 from "../Assest/images/simple-gile.png";

const banners = [
  {
    offer: "FLAT 10% OFF",
    title: "Stylish Eyeglasses",
    img: EyeImg,
    bg: "#f6e9e2",
    link: "/category?type=eyeglasse",
  },
  {
    offer: "FLAT 15% OFF",
    title: "Trendy Sunglasses",
    img: EyeImg1,
    bg: "#ece6f6",
    link: "/category?type=sunglasses",
  },
  {
    offer: "FLAT 20% OFF",
    title: "Power Sunglasses",
    img: EyeImg2,
    bg: "#f4efe6",
    link: "/category?type=power-sunglasses",
  },
  {
    offer: "FLAT 25% OFF",
    title: "Computer Glasses",
    img: EyeImg3,
    bg: "#e2f4ee",
    link: "/category?type=computer-glasses",
  },
];

const NewCurations = () => {


  

  return (
  <section className="offer-section">
      <div className="offer-grid">
        {banners.map((item, index) => (
          <div
            className="offer-card"
            key={index}
            style={{ backgroundColor: item.bg }}
          >
            <div className="offer-content">
              <span className="offer-tag">{item.offer}</span>
              <h3>
                {item.title.split("\n").map((line, i) => (
                  <span key={i}>{line}<br /></span>
                ))}
              </h3>
 <Link to={item.link} className="shop-link">
                SHOP NOW
              </Link>            </div>

            <div className="offer-image">
              <img src={item.img} alt="Sunglasses" />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default NewCurations;
